const Status = {
  created: 'Registered',
  registered: 'Registered',
  approved: 'Approved',
  rejected: 'Rejected',
  Online: 'Online',
  Offline: 'Offline',
  true: 'Yes',
  false: 'No',
  undefined: 'No',
  yes: 'Yes',
  no: 'No',
  approved: 'Approved',
  created: 'New',
  rejected: 'Rejected',
  draft: 'Draft',
  active: 'Active',
  inactive: 'In Active',
  confirmed: 'Confirmed',
  searching: 'Searching',
  schedule: 'scheduled',
  started: 'Started',
  completed: 'Completed',
  cancel: 'Cancelled',
  Offline: 'Offline',
  active: 'Active',
  pending: 'Pending',
  cancelled: 'Cancelled',
  returned: 'Returned',
  return_on_route: 'Return on Route',
  unable_to_deliver_will_reattemp: 'Unable to Deliver, Will Reattempt',
  left_at_door: 'Left at Door',
  delivered_with_concierge: 'Delivered with Concierge',
  unable_to_deliver_returned_to_warehouse: 'Unable to Deliver - Returned to Warehouse',
  handover_to_Pharmacy: 'Handover to Pharmacy',
  declined: 'Declined',
  picked: 'Picked',
  assigned: 'Assigned',
  draft: 'Draft',
  new: 'New',
  refill: 'Refill',
  rx: 'Rx',
  otc: 'OTC',
  cash: 'Cash',
  stripe: 'Card',

  pending: 'Pending',
  sent: 'Sent',
  confirm: 'Confirm',

  // "pending", "confirmed", "declined", "picked", "completed", "cancelled"
};
const StatusFR = {
  created: 'Nouveau',
  registered: 'Enregistré',
  approved: 'Approuvé',
  rejected: 'Rejeté',
  Online: 'En ligne',
  Offline: 'Hors ligne',
  true: 'Oui',
  false: 'Non',
  undefined: 'Non',
  yes: 'Oui',
  no: 'Non',
  draft: 'Brouillon',
  active: 'Actif',
  inactive: 'Inactif',
  confirmed: 'Confirmé',
  searching: 'Recherche en cours',
  schedule: 'Planifié',
  started: 'Commencé',
  completed: 'Terminé',
  cancel: 'Annulé',
  pending: 'En attente',
  cancelled: 'Annulé',
  returned: 'Retourné',
  return_on_route: 'Retour en cours de livraison',
  unable_to_deliver_will_reattemp: 'Impossible de livrer, nouvelle tentative prévue',
  left_at_door: 'Laissé à la porte',
  delivered_with_concierge: 'Livré au concierge',
  unable_to_deliver_returned_to_warehouse: 'Impossible de livrer - Retourné à l’entrepôt',
  handover_to_Pharmacy: 'Transféré à la pharmacie',
  declined: 'Refusé',
  picked: 'Pris en charge',
  assigned: 'Assigné',
  new: 'Nouveau',
  refill: 'Renouvellement',
  rx: 'Ordonnance',
  otc: 'Sans ordonnance',
  cash: 'Espèces',
  stripe: 'Carte',

  sent: 'Envoyé',
  confirm: 'Confirmer',
};
export function getStatusMap(lang = 'en') {
  const language = lang === 'fr' ? 'fr' : 'en';
  const returned = language === 'fr' ? StatusFR : Status;
  return returned;
}
export default Status;